import { Component, Input, OnChanges } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
} from "@angular/forms";
import { ChangeDetectorRef } from "@angular/core";

import { RequestForm } from "../../../../partials/form-state/form-state.component";

@Component({
	selector: "user-team",
	templateUrl: "./user-team.component.html",
})
export class UserTeamComponent implements OnChanges {
	@Input() user: any;

	teams: any[] = [];
	
	form = new RequestForm(
		true,
		new UntypedFormGroup({
			teamId: new UntypedFormControl(""),
		})
	);

	constructor(private http: HttpClient, private change: ChangeDetectorRef) {
		this.loadTeams();
	}

	ngOnChanges() {
		if (this.user) {
			this.form.controls.setValue({ teamId: this.user.team?.id || "" });
		}
	}

	loadTeams() {
		this.http.get("/api/teams").subscribe(
			(teams: any[]) => {
				this.teams = teams;
				this.change.detectChanges();
			},
			(error) => {
				console.error("Failed to load teams:", error);
			}
		);
	}

	setTeam() {
		if (this.form.working) return;

		this.form.setWorking();
		let teamId = this.form.getValue().teamId;
		let payload = { teamId: teamId || null };
		
		this.http
			.put(`/api/users/${this.user.id}/team`, payload)
			.subscribe(
				() => {
					this.form.setSuccess("Avdelning uppdaterad");
					// Update the user object with the new team
					if (teamId) {
						const selectedTeam = this.teams.find(t => t.id == teamId);
						this.user.team = selectedTeam;
					} else {
						this.user.team = null;
					}
				},
				(error) => {
					this.form.setError("Fel: " + error.error);
				}
			)
			.add(() => this.change.detectChanges());
	}
}